import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    sidmodal: '',
    sdescripcionmodal: '',
    sbanderamodal: null,

    //sidcliente: 1002,

    scedulacliente: null,
    sidtipodocumentocliente: '',
    sprimernombrecliente: '',
    ssegundonombrecliente: '',
    sprimerapellidocliente: '',
    ssegundoapellidocliente: '',
    sdireccioncliente: '',
    sidpoblaciondane: 1,
    stelefonocliente: '',
    scelularcliente: '',
    ssexo: '',
    sdescuento: '',
    sidcliente:'',
    sidusuario: '',
    sestadocliente: [],
    semailcliente: '',
    clientes: [],
    cliente: [],
    tiposdocumentos: [],
    datosdescuentos: [],
    descuentos: []


  },
  mutations: {
    cargardatosdescuentoss(state) {


      var token = store.state.numero;
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/descuentos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.datosdescuentos = response.data.data;


        });



    },

    LoadProductos(state, buscar) {
      //let aux = [];
      state.cliente = state.clientes;

      let aux = state.clientes.filter((x) => x["primernombrecliente"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.cliente = state.clientes;
      } else {
        state.cliente = aux;

      }
    },




    async cargardatosclientes(state) {

      state.clientes = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/clientes", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.clientes = response.data.data;

        });
      state.cliente = state.clientes
    },

    cambio(state, api) {
      // state.sidcliente = api.idcliente,
        state.ssexo = api.sexo,
        state.sestadocliente = api.estadocliente,
        state.sdescuento = api.iddescuentocliente,
        state.scedulacliente = api.cedulacliente,
        state.sidtipodocumentocliente = api.idtipodocumentocliente,
        state.sprimernombrecliente = api.primernombrecliente,
        state.ssegundonombrecliente = api.segundonombrecliente
        state.sprimerapellidocliente = api.primerapellidocliente,
        state.ssegundoapellidocliente = api.segundoapellidocliente,
        state.sdireccioncliente = api.direccioncliente,
        state.stelefonocliente = api.telefonocliente,
        state.scelularcliente = api.celularcliente,
        state.descuentos = api.iddescuentocliente,
        state.sidusuario = store.state.user,
        state.sidcliente = api.idcliente,
        state.sfechacreacioncliente = api.fechacreacioncliente,
        state.semailcliente = api.emailcliente

    },

    cargardatosdocumentoss(state) {

      const token = store.state.numero;
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.tiposdocumentos = response.data.data;


        });

    },





    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        sexo: state.ssexo,
        cedulacliente: state.scedulacliente,
        idtipodocumentocliente: state.sidtipodocumentocliente,
        primernombrecliente: state.sprimernombrecliente,
        segundonombrecliente: state.ssegundonombrecliente,
        primerapellidocliente: state.sprimerapellidocliente,
        segundoapellidocliente: state.ssegundoapellidocliente,
        direccioncliente: state.sdireccioncliente,
        idpoblaciondane: state.sidpoblaciondane,
        telefonocliente: state.stelefonocliente,
        celularcliente: state.scelularcliente,
        iddescuentocliente: state.sdescuento,
        idusuario: store.state.user,
        estadocliente: state.sestadocliente,
        emailcliente: state.semailcliente,


      };

      this.banderamodal = store.state.banderamodal



      var datosfalso = state.sidcliente;

      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/clientes", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;


          })

          .catch((e) => {
            console.log(e);
          });
      } else {

        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/clientes/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
         
          })

          .catch((e) => {
            console.log(e);
          });
      }
      state.scedulacliente = '',
      state.ssexo = ''
        state.sidcliente = ''
        state.sidtipodocumentocliente =''
        state.sprimernombrecliente = ''
        state.ssegundoapellidocliente =''
        state.sprimerapellidocliente = ''
        state.ssegundonombrecliente = ''
      state.sdireccioncliente = ''
       
        state.stelefonocliente = ''
        state.scelularcliente = ''
        state.sfechacreacioncliente = ''
        state.sestadocliente =''
        state.semailcliente ='' 
        state.sdescuento = ''
        



    },

    datosmodal(state, api) {

      state.scedulacliente = api.cedulacliente,
      state.ssexo = api.sexo,
        state.sidcliente = api.idcliente,
        state.sidtipodocumentocliente = api.idtipodocumentocliente,
        state.sprimernombrecliente = api.primernombrecliente,
        state.ssegundonombrecliente = api.segundonombrecliente
        state.sprimerapellidocliente = api.primerapellidocliente,
        state.ssegundoapellidocliente = api.segundoapellidocliente,
      state.sdireccioncliente = api.direccioncliente,
        state.sidpoblaciondane = api.idpoblaciondane,
        state.stelefonocliente = api.telefonocliente,
        state.scelularcliente = api.celularcliente,
        state.sidusuario = api.idusuario,
        state.sfechacreacioncliente = api.fechacreacioncliente,
        state.sestadocliente = api.estadocliente,
        state.semailcliente = api.emailcliente,
        state.sdescuento = api.iddescuentocliente
      
    },






    eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;

      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/clientes/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;

          //this.bandera = true;
        })

        .catch((e) => {
          console.log(e);
        });



    },



  },
  actions: {

  },
  getters: {


  },






}